import { render, staticRenderFns } from "./SchoolEnrollment.vue?vue&type=template&id=6efc5ee8&scoped=true&"
import script from "./SchoolEnrollment.vue?vue&type=script&lang=js&"
export * from "./SchoolEnrollment.vue?vue&type=script&lang=js&"
import style0 from "./SchoolEnrollment.vue?vue&type=style&index=0&id=6efc5ee8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efc5ee8",
  null
  
)

export default component.exports